import { HttpCodes } from '@/constants/api.constant';

type AxiosLikeError = {
    response?: { status?: number; data?: { message?: string } };
    code?: string;
    message?: string;
};

export function getAxiosErrorMessage(error: unknown, fallback = 'Something went wrong'): string {
    if (!error || typeof error !== 'object') return fallback;

    const { response, code, message } = error as AxiosLikeError;
    const status = response?.status;
    const serverMessage = response?.data?.message;

    if (status === HttpCodes.Unauthorized) {
        return serverMessage || 'Unauthorized (401): Invalid email or password.';
    }

    if (status) {
        return serverMessage || `Request failed (${status}).`;
    }

    if (code === 'ERR_NETWORK' || code === 'ECONNABORTED' || !response) {
        return 'Cannot reach the server. Make sure the backend is running and VPN is connected.';
    }

    return serverMessage || message || fallback;
}
